import React from "react"
import { Grid } from "@mui/material"

import {UserSettingsSitesTabButton, UserSettingsSitesTable, UserSettingSitesDrawer} from "./Sites"
import {UserSettingsProvidersTabButton, UserSettingsProvidersTable, UserSettingProvidersDrawer} from "./Providers"


export default function UserSettingsWebsitesTab() {
    return <Grid container spacing={1}>
		<Grid item xs={6} sx={{  display: 'flex', justifyContent: "flex-end"  }}>
			<UserSettingsSitesTabButton />
		</Grid>

		<Grid item xs={6} sx={{  display: 'flex', justifyContent: "flex-end"  }}>
			<UserSettingsProvidersTabButton />
		</Grid>

		<Grid item xs={6}>
			<UserSettingsSitesTable />
		</Grid>

		<Grid item xs={6}>
			<UserSettingsProvidersTable />
		</Grid>

		<UserSettingSitesDrawer />
		<UserSettingProvidersDrawer />
    </Grid>
}